// extracted by mini-css-extract-plugin
module.exports = {"container":"WorkCompleteCard_container__LVJpT","card":"WorkCompleteCard_card__iWpou","section":"WorkCompleteCard_section__fx2Zx"};